import {
    DELIVERABLE_TYPE_APP,
    DELIVERABLE_TYPE_CM4G,
    DELIVERABLE_TYPE_DISTRO,
    DELIVERABLE_TYPE_FILE,
} from '~/features/deliverables/constants/deliverablesParameters';
import { env } from '~/env';

const deliverablesDefaultUrlsSuffix = {
    [DELIVERABLE_TYPE_APP]: 'packages/',
    [DELIVERABLE_TYPE_FILE]: 'file/',
    [DELIVERABLE_TYPE_DISTRO]: 'fullsystem/',
    [DELIVERABLE_TYPE_CM4G]: 'cm4g/',

};
export const deliverablesDefaultUrl = (deliverableType: string): string => {
    const { downloadBaseUrl, downloadCM4GUrl } = env.runtimeConfig;
    return deliverableType === DELIVERABLE_TYPE_CM4G ? downloadCM4GUrl : ` ${downloadBaseUrl}${deliverablesDefaultUrlsSuffix[deliverableType]}`;
};
